import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "66",
  height: "40",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.143 9.424a1 1 0 0 1 1.714 0l2.875 4.776a1 1 0 0 0 .63.459l5.432 1.258a1 1 0 0 1 .53 1.63l-3.655 4.21a1 1 0 0 0-.241.742l.482 5.554a1 1 0 0 1-1.387 1.007l-5.133-2.175a1 1 0 0 0-.78 0l-5.133 2.175a1 1 0 0 1-1.387-1.007l.482-5.554a1 1 0 0 0-.24-.742l-3.655-4.21a1 1 0 0 1 .53-1.63l5.43-1.258a1 1 0 0 0 .631-.459zM36.716 24.068v-2.193l4.767-7.511h1.949v2.977h-1.13l-2.79 4.42v.091h6.903v2.216zM42.336 26v-2.602l.056-.96v-8.074h2.63V26zm8.962-1.682v-8.227h2.29v8.227zm-2.972-2.966v-2.295h8.228v2.295z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }